module.exports = __webpack_public_path__ + "img/Mali.39951d9e.svg";